<template>
  <div class="inline-block">
    <span ref="buttonWrapper">
      <slot name="button" />
    </span>

    <div ref="dropdown" class="relative z-10">
      <Transition name="fadeDown">
        <div
          v-if="active"
          class="absolute right-0 top-full mt-2 flex min-w-[200px] flex-col gap-1 rounded-md border bg-white p-1 shadow"
        >
          <slot name="default" />
        </div>
      </Transition>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onClickOutside } from '@vueuse/core';
import { ref } from 'vue';
const dropdown = ref<HTMLDivElement | null>(null);
const buttonWrapper = ref();
onClickOutside(dropdown, () => emit('update:active', false), {
  ignore: [buttonWrapper]
});
defineProps({
  active: {
    type: Boolean,
    default: false
  }
});
const emit = defineEmits<{
  'update:active': [value: boolean];
}>();
</script>
